/**
 * LandingHowItWorks — four-step process section.
 *
 * Light surface. Each step has a huge faded watermark numeral
 * (01 / 02 / 03 / 04), an orange icon tile, a title, and a tight
 * description. The watermark numerals do the visual heavy lifting.
 * Direct visual mirror of NoRework's "How it works" section.
 */

import { type ReactNode }                                       from 'react'
import { ClipboardList, Smartphone, Camera, CheckCircle2 }     from 'lucide-react'
import {
  HOW_HEADLINE,
  HOW_SUBHEAD,
  HOW_STEPS,
  type HowStep,
}                                                                from './landingCopy'

const ICON_BY_NAME: Record<HowStep['icon'], typeof ClipboardList> = {
  ClipboardList,
  Smartphone,
  Camera,
  CheckCircle2,
}

export function LandingHowItWorks(): ReactNode {
  return (
    <section className="landing-section" aria-labelledby="how-h" style={{ background: '#FAFAFA' }}>
      <div className="landing-section__inner">
        <h2 id="how-h" className="landing-section__eyebrow">{HOW_HEADLINE}</h2>
        <p className="landing-section__lede">{HOW_SUBHEAD}</p>

        <div className="how-grid">
          {HOW_STEPS.map((step, idx) => {
            const Icon  = ICON_BY_NAME[step.icon]
            const tone  = idx % 2 === 0 ? 'orange' : 'green'
            return (
              <div key={step.step} className="how-step">
                <span className="how-step__num" aria-hidden="true">{step.step}</span>
                <span className={`how-step__icon icon-tile icon-tile--${tone}`}>
                  <Icon size={22} strokeWidth={2} />
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
